export function collebration_permission(collebrations, collebration_id, permission_id) {
    let allow = false
    let message = "اجازه دسترسی ندارید"

    if (collebration_id <= 0) {
        allow = true
        message = "دسترسی فروشگاه"

        return { allow, message }
    }
    let permission = collebrations.filter(c => c.collebration_id == collebration_id && c.permission_id == permission_id) ?? []

    if (permission.length > 0) {
        if (permission[0]["checked"]) {
            allow = true
            message = "اجازه دسترسی دارید"
        } else {
            allow = false
            message = "اجازه دسترسی ندارید"
        }
    }

    return { allow, message }
}